import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom"
import { Select, Spin, message, Pagination, AutoComplete } from 'antd'
import SettingBoxesTable from './SettingBoxesTable'
import UseDebounce from '../../helpers/UseDebounce'
import { SearchOutlined } from '@ant-design/icons'
import { getListShippingBox } from '../../../services/api/apiShippingCarrier'
import { getListShippingCarrier } from '../../../services/api/apiShippingCarrier'

const Option = Select.Option

function SettingBoxesPage() {
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [total, setTotal] = useState(1)
    const [error, setError] = useState('')
    const [listBoxes, setListBoxes] = useState([])
    const [slug, setSlug] = useState([])
    const [slugSearch, setSlugSearch] = useState('')
    const [boxName, setBoxName] = useState('')
    const [boxNames, setBoxNames] = useState([])
    const [boxType, setBoxType] = useState([])
    const [listShippingCarrier, setListShippingCarrier] = useState([])

    // const debounceSlug = UseDebounce(slug, 1000)
    const debounceBoxName = UseDebounce(boxName, 1000)

    const fetchListBoxes = async () => {
        try {
            setLoading(true)
            setError('')
            const payload = {
                page: page,
                limit: limit,
            }
            if (slug && slug.length > 0) payload.shipping_carriers = slug
            if (boxName) payload.box_name = boxName
            if (boxType && boxType.length > 0) payload.box_type = boxType
            const { data, success, message: mess } = await getListShippingBox(payload)
            if (!success) {
                throw new Error(mess)
            }
            setListBoxes(data.boxes)
            setBoxNames(data.boxNames || [])
            setPage(data.page)
            setTotal(data.total)
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchListBoxes()
    }, [page, limit, slug, debounceBoxName, boxType])

    const onChangeInput = (field, value) => {
        if (field === 'boxName') setBoxName(value)
        setPage(1)
    }
    const onChangeSelect = (field, value) => {
        if (field === 'slug') {
            setSlugSearch('')
            setSlug([...value])
        }
        if (field === 'boxType') setBoxType(value || [])
        setPage(1)
    }

    const onPageChange = (page, pageSize) => {
        setPage(page)
    }
    const onLimitChange = (page, pageSize) => {
        setLimit(pageSize)
        setPage(1)
    }

    const fetchListShippingCarrier = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10000,
            }
            const { data, success, message: mess } = await getListShippingCarrier(payload)
            if (!success) {
                throw new Error(mess)
            }
            setListShippingCarrier(data.shippingCarriers || [])
        } catch (error) {
            message.error(error.message)
        }
    }

    useEffect(() => {
        fetchListShippingCarrier()
    }, [])

    const slugOptions = listShippingCarrier.length > 0 ? listShippingCarrier.sort((a, b) => {
        const nameA = a.slug.toUpperCase()
        const nameB = b.slug.toUpperCase()
        if (nameA < nameB) { return -1 }
        if (nameA > nameB) { return 1 }
        return 0
    }).map((i, index) => ({ label: i.slug, value: i.slug, })) : []

    const boxNameOptions = boxNames.length > 0 ? boxNames.sort().map(i => ({
        value: i,
        label: i,
    })) : []

    const handleSearch = (value) => {
        if (value && value.includes(',')) {
            const newValue = [...new Set([...value.replace(/ /g, ',').split(',').map(i => i.trim()).filter(i => i), ...slug])]
            setSlug(newValue)
            setSlugSearch('')
        } else return setSlugSearch(value)
    }

    return (
        <div className='SettingBoxesPage'>
            <div className="BackWrapper">
                <Link to='/shipping-carrier'><i className='fa fa-chevron-left mr-1' />Shipping Carrier Management</Link>
            </div>
            <div className="TitlePage d-flex justify-content-between align-items-center">
                <h1>Shipping Boxes</h1>

                <div className='action'>
                    <Link to='/setting-boxes-new' className='btn btn-primary ml-3'>
                        Create Box
                    </Link>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="SettingBoxesFilters">
                        <div className="d-flex">
                            <div className="itemFilter mr-3 mb-3">
                                <Select
                                    mode='tags'
                                    allowClear
                                    showArrow
                                    showSearch
                                    placeholder='Search for Slug'
                                    value={slug || []}
                                    onChange={(value) => onChangeSelect('slug', value)}
                                    style={{ width: '350px' }}
                                    suffixIcon={<SearchOutlined />}
                                    onSearch={handleSearch}
                                    searchValue={slugSearch}
                                    options={slugOptions}
                                >
                                </Select>
                            </div>
                            <div className="itemFilter mr-3 mb-3">
                                <AutoComplete
                                    allowClear
                                    placeholder='Search for Box name'
                                    value={boxName || ''}
                                    onChange={(value, e) => onChangeInput('boxName', value)}
                                    style={{ minWidth: '250px' }}
                                    options={boxNameOptions}
                                    suffixIcon={<SearchOutlined />}
                                    showArrow
                                    filterOption={(inputValue, option) =>
                                        !!option && option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                />
                            </div>
                            <div className="itemFilter mr-3 mb-3">
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder='Shipping box type'
                                    value={boxType || []}
                                    onChange={(value) => onChangeSelect('boxType', value)}
                                    style={{ minWidth: '200px' }}
                                >
                                    <Option value={'combination'}>Combination box</Option>
                                    <Option value={'split'}>Split box</Option>
                                </Select>
                            </div>
                        </div>
                    </div>
                    <div>
                        <Spin spinning={loading} tip='Loading...'>
                            {error && <div className="text-danger">{error}</div>}
                            <SettingBoxesTable
                                listBoxes={listBoxes}
                                reset={fetchListBoxes}
                            />
                        </Spin>
                    </div>
                    <div className="OrdersPagination d-flex justify-content-end Pagination">
                        <Pagination current={page} total={total} pageSize={limit} onChange={onPageChange} onShowSizeChange={onLimitChange}
                            className='text-right' showSizeChanger pageSizeOptions={['10', '20', '50', '100']}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SettingBoxesPage